/* Both Profiles pages open at their top: the shell's content pane keeps its scroll across
 * navigation, so a page opened from the bottom of another would otherwise land part-way down. */

/** Scroll an element to the top of its scrolling pane, where the browser can. Guarded the way
 * `CopilotConsole` guards it: a missing method must not cost a reader the page. */
export function scrollToStart(element: HTMLElement | null): void {
  if (element !== null && 'scrollIntoView' in element) {
    element.scrollIntoView({ block: 'start' });
  }
}
